import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import role from "./modules/role";
import order from "./modules/order";
import getters from "./getters";

Vue.use(Vuex);

const store = {
  modules: {
    user,
    role,
    order
  },
  actions: {
    init({ commit, dispatch }) {
      dispatch("restoreUser");
    }
  },
  getters
};

export default new Vuex.Store(store);
